<template>
  <div class="detail">
    <div class="content">
      <a-spin v-if="loading" tip="Loading..."><div class="spin-content"></div></a-spin>
      <div v-if="sItem == 1">
        <h2>“浓情端午，‘粽’享爱心”助老公益活动圆满举行<div class="time">2019年06月07日</div></h2>
        <div class="text">
          <p>6月6日，为迎接端午佳节，金螳螂公益慈善基金会举办 “浓情端午，‘粽’享爱心”助老公益活动，来自金螳螂志愿者团队美瑞德支队的15名志愿者齐聚金狮老人日间照料中心（金螳螂公益慈善基金会2018年捐建），与爷爷奶奶们共同感受节日的气氛，为他们送去了节日的祝福以及精心准备的慰问品。</p>
          <img src="http://fundation.goldmantis.com:8444/files/news/new11.png"/>
          <p>本次活动共分为做保健操、才艺表演、缝香囊三个环节。首先由康复师带领爷爷奶奶们做保健操，志愿者则在一旁协助，确保安全。做完保健操后的休息时间，志愿者为爷爷奶奶们带来了精彩的歌曲演唱，歌声婉转优美，带动了在场的每一个人加入到了这段协奏曲中，歌声在室内回响，场面温馨和谐，每个人的脸上都洋溢着温暖的笑容。缝香囊的环节中，更是调动了爷爷奶奶们和志愿者的热情，经过共同努力，一个个精美的香囊呈现在大家的眼前，志愿者们将自己亲手做的香囊以及精心准备粽子一起送给了爷爷奶奶们，祝福他们节日快乐。</p>
          <img src="http://fundation.goldmantis.com:8444/files/news/new12.png"/>
          <p>我们一直坚守“扶贫济困、关爱弱势亲体，关注民生、注重教育事业”的宗旨，传递正能量，弘扬中华民族的优良美德，本次活动也展示了金螳螂志愿者对困难老人的关心和爱护，我们定当积极推动助老公益项目的开展，让每一位困难老人感受到家的温暖，让他们的晚年生活变得更加丰富多彩、幸福美满。</p>
          <img src="http://fundation.goldmantis.com:8444/files/news/new13.png"/>
        </div>
        <div class="tip">
          <p>金螳螂公益慈善基金会</p>
          <p>二〇一六年六月二十三日</p>
        </div>
      </div>
      <div v-if="sItem == 4">
        <h2>金螳螂公益慈善基金会荣获“中国慈善榜慈善榜样”<div class="time">2019年05月05日</div></h2>
        <div class="text">
          <p>近日，第十六届（2019）中国慈善榜在北京隆重发布，金螳螂公益慈善基金会荣获“中国慈善榜慈善榜样”，海内外热衷公益慈善事业的各方代表一起见证了这一荣耀时刻。</p>
          <p>金螳螂公益慈善基金会成立4年来,通过系统地梳理逐步形成了:一个平台,六大模块,两支队伍。在金螳螂公益慈善基金会这一平台上开展了涉及“教育、医疗、养老、助残、扶贫、赈灾”六大模块的十多个长期公益项目，救助帮扶万余人。集合金螳螂在职员工和合作伙伴的公益力量组建了两支志愿服务队伍,注册人数达千余人,从慰问孤寡老人、残疾儿童、山区退伍军人,到无偿献血、公益送教,累计服务时长超万。在苏州市社会组织党委下成立了第一家基金会党支部，将党建与慈善公益充分融合，创新出具有自己特色的项目。</p>
          <img src="http://fundation.goldmantis.com:8444/files/news/new41.png"/>
          <img src="http://fundation.goldmantis.com:8444/files/news/new42.png"/>
          <p>慈善，不是一个人做了很多，而是很多人做了一点点，感谢每一位金螳螂人，让这点点滴滴的爱汇聚成海洋。公益慈善的路上，我们一起前行。</p>
        </div>
        <div class="tip">
          <p>金螳螂公益慈善基金会</p>
          <p>二〇一九年五月五日</p>
        </div>
      </div>
      <div v-if="sItem == 5">
        <h2>爱心捐助 贵州娃娃在苏成功“补心”<div class="time">2019年05月10日</div></h2>
        <div class="text">
          <p>近日，来自贵州松桃县6个月大的先心病患儿小兴（化名），在苏大附儿院成功接受了“补心”手术。得益于2万多元爱心基金的医疗资助，患者的家庭负担大大减轻。</p>
          <img src="http://fundation.goldmantis.com:8444/files/news/new51.png"/>
          <p>来自贵州松桃县平头镇的高登山女儿小兴，出生仅4个月就被确诊为先天性心脏病，并伴发严重肺炎。由于当地医院治疗条件有限，高登山夫妇带着小兴乘坐10多个小时的火车赶到苏大附儿院就诊。经仔细评估病情，近日该院心胸外科副主任医师廖健毅为小兴实施心脏手术。术后评估小兴心脏畸形得到了纠治，目前恢复良好，再观察两三天就可回到父母身边。</p>
          <img src="http://fundation.goldmantis.com:8444/files/news/new52.png"/>
          <p>然而，5万多元的医疗费用成为他们面临的最大难题。据了解，小兴全家人的生活收入只靠着爸爸高登山在当地镇上打零工。考虑到患者家庭的实际困难，廖健毅推荐他们申请 “情暖心窝”爱心基金，得到了2万多元的医疗费用捐助。</p>
          <p>“情暖心窝”专项救助基金由苏州金螳螂公益慈善基金会在苏大附儿院设立的专项救助基金，主要救助对象为患有先天性心脏病、重度耳聋以及其他特殊情形的家庭贫困患儿。2015年至今，爱心基金已救助过包括偏远地区贫困家庭在内的46名患儿，捐助金额130多万元。（苏报融媒记者 周函 来源：姑苏晚报）</p>
        </div>
        <div class="tip">
          <p>金螳螂公益慈善基金会</p>
          <p>二〇一九年五月十日</p>
        </div>
      </div>
      <div v-if="sItem > 5">
        <h2 style="margin-bottom: 0;">{{ndetail.title}}<br/><span style="font-size: 12px; color: #9D6835;" v-if="ndetail.count">阅读次数：{{ndetail.count}}</span></h2>
        <div v-html="ndetail.richText"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'newd',
  data () {
    return {
      loading: true,
      sItem: 0,
      ndetail: {}
    }
  },
  components: {
  },
  mounted() {
    this.init();
  },
  methods: {
    init () {
      if(this.$route.params.id){
        this.sItem = this.$route.params.id;
      }
      if(this.sItem > 5){
        this.$store.dispatch('ajaxNewDetail',{
          id: this.$route.params.id,
          jobcode: 'L075703'
        }).then((result) => {
          this.loading = false;
          this.ndetail = result;
        })
      }else{
        this.loading = false;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../scss/views/detail';
</style>
